import { buildApiUrl } from "../utils/apiConfig";
import { jsonGet, jsonSend } from "../utils/http";

export type ProgramDocumentDto = {
    id: number;
    name: string;
    createdAt: string;
    s3Key?: string | null;
};

export type ProgramDocumentPage = {
    content: ProgramDocumentDto[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
};

export type ProgramUploadUrlResponse = {
    uploadUrl: string;
    s3Key: string;
    contentType: string;
};

export function fetchProgramDocuments(
    pageZeroBased: number,
    pageSize: number,
    companyId?: number | null,
    nameContains?: string | null,
    forAthleteProfileId?: number | null
) {
    const params = new URLSearchParams();
    params.set("page", String(pageZeroBased));
    params.set("size", String(pageSize));
    if (companyId != null && companyId !== undefined) {
        params.set("companyId", String(companyId));
    }
    const trimmed = nameContains?.trim();
    if (trimmed) {
        params.set("nameContains", trimmed);
    }
    if (forAthleteProfileId != null && forAthleteProfileId !== undefined) {
        params.set("forAthleteProfileId", String(forAthleteProfileId));
    }
    return jsonGet<ProgramDocumentPage>(`${buildApiUrl("api/documents")}?${params.toString()}`);
}

export function requestProgramUploadUrl(fileName: string, companyId?: number | null) {
    return jsonSend<ProgramUploadUrlResponse>(
        buildApiUrl("api/documents/upload-url"),
        "POST",
        { fileName, companyId: companyId ?? null }
    );
}

export function confirmProgramUpload(payload: {
    s3Key: string;
    name: string;
    companyId?: number | null;
    documentId?: number | null;
}) {
    return jsonSend<ProgramDocumentDto>(buildApiUrl("api/documents/confirm"), "POST", {
        s3Key: payload.s3Key,
        name: payload.name,
        companyId: payload.companyId ?? null,
        documentId: payload.documentId ?? null,
    });
}

export function getProgramDocumentDownloadUrl(documentId: number, forAthleteProfileId?: number | null) {
    const params = new URLSearchParams();
    if (forAthleteProfileId != null && forAthleteProfileId !== undefined) {
        params.set("forAthleteProfileId", String(forAthleteProfileId));
    }
    const q = params.toString();
    const suffix = q ? `?${q}` : "";
    return jsonGet<{ url: string }>(buildApiUrl(`api/documents/${documentId}/download-url${suffix}`));
}

export function deleteProgramDocument(documentId: number) {
    return jsonSend<void>(buildApiUrl(`api/documents/${documentId}`), "DELETE");
}

export function renameProgramDocument(documentId: number, name: string) {
    return jsonSend<ProgramDocumentDto>(buildApiUrl(`api/documents/${documentId}`), "PATCH", { name });
}
